 <div class="empty-page-data">
    <div class="content">
        <img src="../../../../assets/svg/empty-state-rev.svg" alt="No Records Found" id="img_NoRecordsFound" />
        <p class="records" >
            <!--binding the displaymessage object-->
            {{ displayMessage }}
        </p>
    </div>
</div>